var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.03,
    height: 18.056,
    viewBox: "0 0 18.03 18.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160352",
    "data-name": "Group 160352",
    transform: "translate(-1285.985 -680.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recharge_18",
    transform: "translate(1286 681)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209",
    transform: "translate(0.744 0.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M4.172,16.307l.97.975a8.22,8.22,0,0,0,11.674-.046,8.335,8.335,0,0,0,2.345-6.76M17.747,6.53l-.969-.976A8.22,8.22,0,0,0,5.1,5.582a8.333,8.333,0,0,0-2.356,6.76",
    transform: "translate(-2.699 -3.136)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M18.8,4.727,18.6,7.6,15.67,7.461M3.234,18.332l.2-2.875,2.926.141",
    transform: "translate(-2.756 -3.306)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_83093",
    "data-name": "Path 83093",
    d: "M291.2,261.1l-3.619,3.408-1.645-1.549",
    transform: "translate(1006.432 427.2)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.546
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateIcon);
export default __webpack_public_path__ + "static/media/activate-icon.7a68916f4b1eb9db8e0c72da36f4e3d4.svg";
export { ForwardRef as ReactComponent };